import React from 'react'

const HighlightText = ({text}) => {
  return (
    <div className="gradient-text inline-block ">
        
        { text}
    </div>
  )
}

export default HighlightText